export const STEP_PRODUCT = 'texts.step1.tabName';
export const STEP_PROFILE = 'texts.step2.tabName';
export const STEP_MATERIALS = 'texts.step3.tabName';
export const STEP_DIMENSIONS = 'texts.step4.tabName';
export const STEP_CONFIRM = 'texts.step5.tabName';
